export const formatSalary = (salary: number, lang: string) =>
  new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: 'PLN',
    maximumFractionDigits: 0,
    maximumSignificantDigits: 3,
  }).format(salary)

export const renderValues = (values: number[], lang: string) =>
  values.map((v: number) => formatSalary(v, lang)).join(' - ')
